import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useServiceCategoryFilterStore = defineStore('serviceCategoryFilter', () => {
  const categoryIds = ref<number[]>([]);
  // The "Sin categoría" bucket: patients with no active assignment.
  const uncategorized = ref(false);

  function clear() {
    categoryIds.value = [];
    uncategorized.value = false;
  }

  return { categoryIds, uncategorized, clear };
}, { persist: true });
